import {useMemo} from "react";
import SentryEchart from "../../../../../../../../components/echarts/sentry-echart.jsx";

export default function RegisteredProgram({data}) {
    const sourceItems = data?.cnpjRegistrationsByProgram;
    const registrationsByProgram = useMemo(() => Array.isArray(sourceItems)
        ? sourceItems.slice(0, 5).map(item => ({
            label: item.label ?? "",
            value: Number(item.qty) || 0,
        }))
        : [], [sourceItems]);

    const registrationsChart = useMemo(() => {
        const values = registrationsByProgram.map(item => item.value);
        const maxValue = Math.max(...values, 1);

        return {
            grid: {
                top: 28,
                left: 8,
                right: 8,
                bottom: 8,
                containLabel: true,
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {type: "shadow"},
                formatter: params => {
                    const coloredBar = params.find(item => item.seriesName === "Quantidade");
                    const item = registrationsByProgram[coloredBar?.dataIndex];

                    return item?.label ? `${item.label}: <b>${item.value}</b>` : "";
                },
            },
            xAxis: {
                type: "category",
                boundaryGap: true,
                data: registrationsByProgram.map(item => item.label),
                axisLabel: {
                    color: "#AAAAAA",
                    fontSize: 12,
                    interval: 0,
                    width: 100,
                    overflow: "truncate",
                    ellipsis: "...",
                },
                axisLine: {
                    show: true,
                    lineStyle: {color: "#555762"},
                },
                axisTick: {show: false},
            },
            yAxis: {
                type: "value",
                min: 0,
                max: maxValue,
                minInterval: 1,
                axisLabel: {
                    show: true,
                    color: "#AAAAAA",
                    fontSize: 12,
                },
                axisTick: {show: false},
                splitLine: {show: false},
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#555762",
                        width: 1,
                    },
                },
            },
            series: [
                {
                    name: "Fundo",
                    type: "bar",
                    barWidth: 44,
                    barGap: "-100%",
                    silent: true,
                    itemStyle: {
                        color: "#4B4B5C",
                        borderRadius: [4, 4, 0, 0],
                    },
                    data: registrationsByProgram.map(() => maxValue),
                    z: 1,
                },
                {
                    name: "Quantidade",
                    type: "bar",
                    barWidth: 44,
                    itemStyle: {
                        borderRadius: [4, 4, 0, 0],
                        color: {
                            type: "linear",
                            x: 0,
                            y: 1,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {offset: 0, color: "#003878"},
                                {offset: 0.5, color: "#0080ED"},
                                {offset: 1, color: "#1CEAE6"},
                            ],
                        },
                    },
                    label: {
                        show: true,
                        position: "top",
                        distance: 8,
                        color: "#FDFCFF",
                        fontSize: 12,
                        fontWeight: "bold",
                        formatter: params => values[params.dataIndex],
                    },
                    data: values,
                    z: 2,
                },
            ],
        };
    }, [registrationsByProgram]);

    return (
        <article className="box-border flex h-full min-h-0 min-w-0 w-full flex-col overflow-hidden">
            <h3 className="shrink-0 px-4 text-center text-(length:--font-md)! text-[#AAAAAA]">
                Cadastros por programas
            </h3>
            <div className="min-h-0 flex-1 px-2 pb-1">
                <SentryEchart
                    className="h-full min-h-0 w-full"
                    option={registrationsChart}
                />
            </div>
        </article>
    );
}
